import type { Tour } from '../../types';

export const configTour: Tour = {
  id: 'platform-config',
  name: 'Configuration Tour',
  description: 'Learn how to configure platform-wide settings',
  category: 'platform',
  showProgress: true,
  requiredPath: '/platform/configuration',
  steps: [
    {
      id: 'config-1',
      target: 'config-header',
      title: 'Platform Configuration',
      content: 'Configure settings that apply across all MDAs. Changes here affect the entire platform.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'config-2',
      target: 'config-doc-types',
      title: 'Document Types',
      content: 'Define the types of documents that can be created in the system: Letters, Memos, Reports, Policies, etc. Each type can have custom metadata fields.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'config-3',
      target: 'config-classifications',
      title: 'Security Classifications',
      content: 'Manage document classification levels (Unclassified, Restricted, Confidential, Secret, Top Secret) and their associated access controls.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'config-4',
      target: 'config-retention',
      title: 'Retention Policies',
      content: 'Set document retention periods and archival rules. Define how long documents should be kept and when they can be disposed of.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'config-5',
      target: 'config-security',
      title: 'Security Settings',
      content: 'Configure password policies, session timeouts, two-factor authentication, and other security parameters.',
      position: 'left',
      spotlight: true,
    },
    {
      id: 'config-6',
      target: 'config-integrations',
      title: 'Integrations',
      content: 'Connect external systems like email servers, SMS gateways, and backup services.',
      position: 'left',
      spotlight: true,
      actionLabel: 'Finish Tour',
    },
  ],
};
